var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"a112a9569414036284a20b41c5f0ca9cce988b8b"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["portal@dados-abertos-de-feira"]={id:"a112a9569414036284a20b41c5f0ca9cce988b8b"};
      